// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Testing module design tokens — scoped to \`.tst-route\`.
 *
 * Same discipline as the Weave token layer (pages/multi-agent/styles/multi-agent-tokens.css),
 * deliberately NOT a copy of it: Testing has different surfaces (a live browser stage, a run
 * inspector, a session list) and needs far fewer tokens. Both files derive every colour from the
 * SAME global shell variables (--background / --card / --border / --primary / --success / …), so the
 * two modules stay one visual system without duplicating values.
 *
 * Rules kept intentionally tight:
 *   - 5 type sizes (micro / meta / body / title / hero) — nothing else in the module
 *   - 1 accent (global --primary) + 4 state colours (ok / warn / err / busy)
 *   - 3 depth tiers, 1 ease, 2 durations
 *   - every panel dimension is a token, so the responsive shell has no magic numbers
 */

.tst-route {
	/* ── Type ─────────────────────────────────────────────────────────────── */
	/* Floor is 11px: the old module bottomed out at 9px, which is below a
	   comfortable reading size and was applied to real content (run ids, timestamps). */
	--tst-fs-micro: 11px;
	--tst-fs-meta: 12px;
	--tst-fs-body: 13px;
	--tst-fs-title: 15px;
	--tst-fs-hero: 20px;

	--tst-leading-tight: 1.35;
	--tst-leading-body: 1.55;
	--tst-tracking-micro: 0.06em;

	/* ── Colour ───────────────────────────────────────────────────────────── */
	--tst-bg: hsl(var(--background));
	--tst-surface: hsl(var(--card));
	--tst-surface-soft: hsl(var(--muted) / 0.4);
	--tst-border: hsl(var(--border));
	--tst-divider: color-mix(in oklab, hsl(var(--border)) 58%, transparent);
	--tst-text: hsl(var(--foreground));
	--tst-text-muted: hsl(var(--muted-foreground));
	--tst-accent: hsl(var(--primary));
	--tst-accent-soft: hsl(var(--primary) / 0.1);

	--tst-state-ok: hsl(var(--success));
	--tst-state-warn: hsl(var(--warning));
	--tst-state-err: hsl(var(--destructive));
	--tst-state-busy: hsl(var(--primary));

	/* Panel chrome — same recipe as Weave so the two modules read as siblings. */
	--tst-app-bg: color-mix(in oklab, hsl(var(--background)) 93%, hsl(var(--foreground)) 7%);
	--tst-panel-bg: color-mix(in oklab, hsl(var(--card)) 94%, hsl(var(--background)) 6%);
	--tst-panel-bg-soft: color-mix(in oklab, hsl(var(--card)) 86%, hsl(var(--background)) 14%);

	/* ── Geometry ─────────────────────────────────────────────────────────── */
	--tst-radius-sm: 6px;
	--tst-radius-md: 10px;
	--tst-radius-lg: 16px;

	/* ── Depth ────────────────────────────────────────────────────────────── */
	--tst-shadow-soft: hsl(var(--foreground) / 0.06);
	--tst-shadow-hard: hsl(var(--foreground) / 0.12);
	--tst-shadow-sm: 0 1px 2px var(--tst-shadow-soft), 0 0 0 1px hsl(var(--border) / 0.7);
	--tst-shadow-md:
		0 4px 6px -1px var(--tst-shadow-soft), 0 2px 4px -2px var(--tst-shadow-soft),
		0 0 0 1px hsl(var(--border) / 0.8);
	--tst-shadow-lg:
		0 18px 28px -10px var(--tst-shadow-hard), 0 6px 10px -4px var(--tst-shadow-soft),
		0 0 0 1px hsl(var(--border) / 0.85);

	/* ── Motion ───────────────────────────────────────────────────────────── */
	--tst-motion: 150ms;
	--tst-motion-lg: 240ms;
	--tst-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);

	/* ── Layout ───────────────────────────────────────────────────────────── */
	/* The single source of truth for panel sizing. useTestingShell reads the
	   numeric equivalents from TESTING_PANEL_LIMITS; these drive the CSS side
	   (rail width, header height, drawer width) so the two never drift. */
	--tst-header-h: 44px;
	--tst-rail-w: 44px;
	--tst-sessions-w-min: 200px;
	--tst-sessions-w-max: 360px;
	--tst-inspector-w-min: 280px;
	--tst-inspector-w-max: 560px;
	--tst-drawer-w: min(88vw, 340px);

	/* Reading measure for the conversation. Without a cap, a 1920px screen stretched every message,
	   plan table and result card edge-to-edge — technically "responsive", unreadable in practice.
	   The gutter scales with the column so the thread keeps its margins as panels resize. */
	--tst-measure: 860px;
	--tst-gutter: clamp(12px, 2.5vw, 32px);
	font-size: var(--tst-fs-body);
	line-height: var(--tst-leading-body);
	color: var(--tst-text);
	background: var(--tst-app-bg);
}

/* ── Panel chrome ───────────────────────────────────────────────────────── */

.tst-route .tst-panel {
	background: linear-gradient(
		180deg,
		color-mix(in oklab, var(--tst-panel-bg) 98%, hsl(var(--foreground)) 2%),
		var(--tst-panel-bg)
	);
	border-color: var(--tst-divider);
}

.tst-route .tst-workspace {
	background: linear-gradient(
		180deg,
		color-mix(in oklab, hsl(var(--background)) 99%, hsl(var(--foreground)) 1%),
		hsl(var(--background))
	);
}

.tst-route .tst-header {
	min-height: var(--tst-header-h);
	border-bottom: 1px solid var(--tst-divider);
	background: linear-gradient(
		180deg,
		color-mix(in oklab, var(--tst-panel-bg) 96%, hsl(var(--foreground)) 4%),
		var(--tst-panel-bg)
	);
}

/* Sub-header strip inside a panel (tab bars, section toolbars). */
.tst-route .tst-toolbar {
	min-height: 34px;
	border-bottom: 1px solid color-mix(in oklab, var(--tst-divider) 46%, transparent);
	background: color-mix(in oklab, var(--tst-panel-bg) 86%, transparent);
}

/* ── Type utilities ─────────────────────────────────────────────────────── */

.tst-route .tst-micro {
	font-size: var(--tst-fs-micro);
	font-weight: 600;
	letter-spacing: var(--tst-tracking-micro);
	line-height: var(--tst-leading-tight);
	text-transform: uppercase;
	color: var(--tst-text-muted);
}

.tst-route .tst-meta {
	font-size: var(--tst-fs-meta);
	line-height: var(--tst-leading-tight);
	color: var(--tst-text-muted);
}

.tst-route .tst-title {
	font-size: var(--tst-fs-title);
	font-weight: 600;
	letter-spacing: -0.011em;
	line-height: 1.3;
	color: var(--tst-text);
}

.tst-route .tst-hero {
	font-size: var(--tst-fs-hero);
	font-weight: 600;
	letter-spacing: -0.014em;
	line-height: 1.25;
	color: var(--tst-text);
}

/* ── Interactive (lift + focus ring) ───────────────────────────────────── */

.tst-route .tst-interactive {
	transition:
		background-color var(--tst-motion) var(--tst-ease),
		box-shadow var(--tst-motion) var(--tst-ease),
		color var(--tst-motion) var(--tst-ease);
}

.tst-route .tst-interactive:focus-visible {
	outline: 2px solid var(--tst-accent);
	outline-offset: 2px;
}

/* ── Overlay drawer (session list / inspector below the lg breakpoint) ──── */

.tst-route .tst-drawer {
	position: absolute;
	top: 0;
	bottom: 0;
	width: var(--tst-drawer-w);
	max-width: var(--tst-drawer-w);
	z-index: 30;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background: var(--tst-panel-bg);
	box-shadow: var(--tst-shadow-lg);
	transition:
		transform var(--tst-motion-lg) var(--tst-ease),
		opacity var(--tst-motion-lg) var(--tst-ease);
}

.tst-route .tst-drawer[data-side="left"] {
	left: 0;
	border-right: 1px solid var(--tst-divider);
	border-top-right-radius: var(--tst-radius-lg);
	border-bottom-right-radius: var(--tst-radius-lg);
	transform: translateX(-100%);
	opacity: 0;
}

.tst-route .tst-drawer[data-side="right"] {
	right: 0;
	border-left: 1px solid var(--tst-divider);
	border-top-left-radius: var(--tst-radius-lg);
	border-bottom-left-radius: var(--tst-radius-lg);
	transform: translateX(100%);
	opacity: 0;
}

.tst-route .tst-drawer[data-open="true"] {
	transform: translateX(0);
	opacity: 1;
}

/* ── Conversation ───────────────────────────────────────────────────────── */

/*
 * One centred reading column. Every block in the thread — user bubble, answer, plan card, run result,
 * composer — uses \`.tst-measure\` so they share one left and one right edge as the panel resizes.
 */
.tst-route .tst-measure {
	width: 100%;
	max-width: var(--tst-measure);
	margin-inline: auto;
	padding-inline: var(--tst-gutter);
}

/* One question-and-answer exchange. The hairline is the only separator in the thread; cards inside a
   turn are grouped by proximity instead of each carrying its own border. */
.tst-route .tst-turn {
	padding-block: 20px;
	border-bottom: 1px solid color-mix(in oklab, var(--tst-border) 55%, transparent);
}
.tst-route .tst-turn:last-of-type {
	border-bottom: 0;
}

/* The user's message: right-aligned, tinted, with the corner nearest the sender squared off. */
.tst-route .tst-user-bubble {
	max-width: min(80%, 560px);
	padding: 9px 13px;
	border-radius: var(--tst-radius-md) var(--tst-radius-md) 4px var(--tst-radius-md);
	background: color-mix(in oklab, hsl(var(--primary)) 10%, hsl(var(--card)));
	border: 1px solid color-mix(in oklab, hsl(var(--primary)) 22%, var(--tst-border));
	color: var(--tst-text);
	font-size: var(--tst-fs-body);
	line-height: 1.55;
	white-space: pre-wrap;
	overflow-wrap: anywhere;
	max-height: 220px;
	overflow-y: auto;
}

/* The agent's live reasoning. A left accent rule rather than a full card, so an in-flight turn reads
   as "in progress" and does not compete with the finished answers above it. */
.tst-route .tst-thinking {
	background: var(--tst-surface-soft);
	border-left: 2px solid hsl(var(--primary) / 0.85);
	border-radius: 0 var(--tst-radius-sm) var(--tst-radius-sm) 0;
	padding: 10px 14px;
}

/*
 * Agent prose. A markdown table or a long code fence is wider than the reading measure on a narrow
 * column, and was simply CLIPPED — the columns past the edge were unreachable. Each wide child
 * becomes its own scroll container so only that block scrolls, never the page.
 */
.tst-route .tst-prose {
	/* Agent prose is full of unbreakable strings — CSS selectors, record ids, URLs, stack frames.
	   Without this a single long token stretched the message past the reading measure and was clipped
	   with no way to scroll to it. */
	overflow-wrap: anywhere;
}

.tst-route .tst-prose table {
	display: block;
	width: -moz-max-content;
	width: max-content;
	max-width: 100%;
	overflow-x: auto;
}
.tst-route .tst-prose pre {
	max-width: 100%;
	overflow-x: auto;
}
.tst-route .tst-prose img {
	max-width: 100%;
	height: auto;
}

/* ── Composer ───────────────────────────────────────────────────────────── */

.tst-route .tst-composer-dock {
	border-top: 1px solid color-mix(in oklab, var(--tst-divider) 60%, transparent);
	background: linear-gradient(
		180deg,
		color-mix(in oklab, var(--tst-app-bg) 60%, transparent),
		var(--tst-panel-bg)
	);
}

.tst-route .tst-composer-shell {
	background: color-mix(in oklab, hsl(var(--background)) 88%, hsl(var(--card)) 12%);
	border: 1px solid var(--tst-border);
	border-radius: var(--tst-radius-md);
	box-shadow: 0 10px 24px -22px hsl(var(--foreground) / 0.35);
	transition:
		border-color var(--tst-motion) var(--tst-ease),
		box-shadow var(--tst-motion) var(--tst-ease);
}
.tst-route .tst-composer-shell:focus-within {
	border-color: hsl(var(--primary) / 0.55);
	box-shadow: 0 0 0 3px hsl(var(--primary) / 0.12);
}

/* ── Entrance ───────────────────────────────────────────────────────────── */

@keyframes tst-fade-up {
	0% {
		opacity: 0;
		transform: translateY(4px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

.tst-route .tst-fade-up {
	animation: tst-fade-up var(--tst-motion-lg) var(--tst-ease) both;
}

/* ── Reduced motion ─────────────────────────────────────────────────────── */
/*
 * The module ships several always-on decorative animations (the result mascot's
 * float/shake, the idle browser scan line, shimmer sweeps on active steps, ping
 * dots). None of them carry information that isn't also in text, so they are all
 * stopped for users who ask for reduced motion. Panel transforms are kept but
 * made instant so layout still lands in the right place.
 */
@media (prefers-reduced-motion: reduce) {
	.tst-route .tst-drawer,
	.tst-route .tst-interactive {
		transition-duration: 1ms;
	}

	.tst-route .tst-fade-up {
		animation: none;
	}

	.tst-route [data-tst-decorative-motion] {
		animation: none !important;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/testing/styles/testing-tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;CACC,4EAA4E;CAC5E;qFACoF;CACpF,oBAAoB;CACpB,mBAAmB;CACnB,mBAAmB;CACnB,oBAAoB;CACpB,mBAAmB;;CAEnB,yBAAyB;CACzB,wBAAwB;CACxB,4BAA4B;;CAE5B,4EAA4E;CAC5E,gCAAgC;CAChC,+BAA+B;CAC/B,2CAA2C;CAC3C,gCAAgC;CAChC,uEAAuE;CACvE,kCAAkC;CAClC,8CAA8C;CAC9C,iCAAiC;CACjC,4CAA4C;;CAE5C,mCAAmC;CACnC,qCAAqC;CACrC,wCAAwC;CACxC,qCAAqC;;CAErC,6EAA6E;CAC7E,wFAAwF;CACxF,oFAAoF;CACpF,0FAA0F;;CAE1F,4EAA4E;CAC5E,oBAAoB;CACpB,qBAAqB;CACrB,qBAAqB;;CAErB,4EAA4E;CAC5E,gDAAgD;CAChD,gDAAgD;CAChD,qFAAqF;CACrF;;oCAEmC;CACnC;;qCAEoC;;CAEpC,4EAA4E;CAC5E,mBAAmB;CACnB,sBAAsB;CACtB,gDAAgD;;CAEhD,4EAA4E;CAC5E;;uEAEsE;CACtE,oBAAoB;CACpB,kBAAkB;CAClB,2BAA2B;CAC3B,2BAA2B;CAC3B,4BAA4B;CAC5B,4BAA4B;CAC5B,gCAAgC;;CAEhC;;yFAEwF;CACxF,oBAAoB;CACpB,sCAAsC;CAItC,6BAA6B;CAC7B,oCAAoC;CACpC,sBAAsB;CACtB,6BAA6B;AAN9B;;AASA,8EAA8E;;AAE9E;CACC;;;;EAIC;CACD,gCAAgC;AACjC;;AAEA;CACC;;;;EAIC;AACF;;AAEA;CACC,+BAA+B;CAC/B,2CAA2C;CAC3C;;;;EAIC;AACF;;AAEA,kEAAkE;AAClE;CACC,gBAAgB;CAChB,iFAAiF;CACjF,qEAAqE;AACtE;;AAEA,8EAA8E;;AAE9E;CACC,8BAA8B;CAC9B,gBAAgB;CAChB,yCAAyC;CACzC,qCAAqC;CACrC,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;CAC7B,qCAAqC;CACrC,4BAA4B;AAC7B;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;CAChB,wBAAwB;CACxB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB,wBAAwB;CACxB,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA,6EAA6E;;AAE7E;CACC;;;yCAGwC;AACzC;;AAEA;CACC,oCAAoC;CACpC,mBAAmB;AACpB;;AAEA,8EAA8E;;AAE9E;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,0BAA0B;CAC1B,8BAA8B;CAC9B,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,gBAAgB;CAChB,+BAA+B;CAC/B,gCAAgC;CAChC;;8CAE6C;AAC9C;;AAEA;CACC,OAAO;CACP,0CAA0C;CAC1C,6CAA6C;CAC7C,gDAAgD;CAChD,4BAA4B;CAC5B,UAAU;AACX;;AAEA;CACC,QAAQ;CACR,yCAAyC;CACzC,4CAA4C;CAC5C,+CAA+C;CAC/C,2BAA2B;CAC3B,UAAU;AACX;;AAEA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA,8EAA8E;;AAE9E;;;EAGE;AACF;CACC,WAAW;CACX,6BAA6B;CAC7B,mBAAmB;CACnB,iCAAiC;AAClC;;AAEA;2EAC2E;AAC3E;CACC,mBAAmB;CACnB,gFAAgF;AACjF;AACA;CACC,gBAAgB;AACjB;;AAEA,+FAA+F;AAC/F;CACC,0BAA0B;CAC1B,iBAAiB;CACjB,iFAAiF;CACjF,0EAA0E;CAC1E,iFAAiF;CACjF,sBAAsB;CACtB,6BAA6B;CAC7B,iBAAiB;CACjB,qBAAqB;CACrB,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;8EAC8E;AAC9E;CACC,mCAAmC;CACnC,iDAAiD;CACjD,4DAA4D;CAC5D,kBAAkB;AACnB;;AAEA;;;;EAIE;AACF;CACC;;kCAEiC;CACjC,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,uBAAkB;CAAlB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,YAAY;AACb;;AAEA,8EAA8E;;AAE9E;CACC,8EAA8E;CAC9E;;;;EAIC;AACF;;AAEA;CACC,iFAAiF;CACjF,mCAAmC;CACnC,mCAAmC;CACnC,2DAA2D;CAC3D;;8CAE6C;AAC9C;AACA;CACC,wCAAwC;CACxC,gDAAgD;AACjD;;AAEA,8EAA8E;;AAE9E;CACC;EACC,UAAU;EACV,0BAA0B;CAC3B;CACA;EACC,UAAU;EACV,wBAAwB;CACzB;AACD;;AAEA;CACC,gEAAgE;AACjE;;AAEA,8EAA8E;AAC9E;;;;;;EAME;AACF;CACC;;EAEC,wBAAwB;CACzB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,0BAA0B;CAC3B;AACD","sourcesContent":["/**\n * Testing module design tokens — scoped to `.tst-route`.\n *\n * Same discipline as the Weave token layer (pages/multi-agent/styles/multi-agent-tokens.css),\n * deliberately NOT a copy of it: Testing has different surfaces (a live browser stage, a run\n * inspector, a session list) and needs far fewer tokens. Both files derive every colour from the\n * SAME global shell variables (--background / --card / --border / --primary / --success / …), so the\n * two modules stay one visual system without duplicating values.\n *\n * Rules kept intentionally tight:\n *   - 5 type sizes (micro / meta / body / title / hero) — nothing else in the module\n *   - 1 accent (global --primary) + 4 state colours (ok / warn / err / busy)\n *   - 3 depth tiers, 1 ease, 2 durations\n *   - every panel dimension is a token, so the responsive shell has no magic numbers\n */\n\n.tst-route {\n\t/* ── Type ─────────────────────────────────────────────────────────────── */\n\t/* Floor is 11px: the old module bottomed out at 9px, which is below a\n\t   comfortable reading size and was applied to real content (run ids, timestamps). */\n\t--tst-fs-micro: 11px;\n\t--tst-fs-meta: 12px;\n\t--tst-fs-body: 13px;\n\t--tst-fs-title: 15px;\n\t--tst-fs-hero: 20px;\n\n\t--tst-leading-tight: 1.35;\n\t--tst-leading-body: 1.55;\n\t--tst-tracking-micro: 0.06em;\n\n\t/* ── Colour ───────────────────────────────────────────────────────────── */\n\t--tst-bg: hsl(var(--background));\n\t--tst-surface: hsl(var(--card));\n\t--tst-surface-soft: hsl(var(--muted) / 0.4);\n\t--tst-border: hsl(var(--border));\n\t--tst-divider: color-mix(in oklab, hsl(var(--border)) 58%, transparent);\n\t--tst-text: hsl(var(--foreground));\n\t--tst-text-muted: hsl(var(--muted-foreground));\n\t--tst-accent: hsl(var(--primary));\n\t--tst-accent-soft: hsl(var(--primary) / 0.1);\n\n\t--tst-state-ok: hsl(var(--success));\n\t--tst-state-warn: hsl(var(--warning));\n\t--tst-state-err: hsl(var(--destructive));\n\t--tst-state-busy: hsl(var(--primary));\n\n\t/* Panel chrome — same recipe as Weave so the two modules read as siblings. */\n\t--tst-app-bg: color-mix(in oklab, hsl(var(--background)) 93%, hsl(var(--foreground)) 7%);\n\t--tst-panel-bg: color-mix(in oklab, hsl(var(--card)) 94%, hsl(var(--background)) 6%);\n\t--tst-panel-bg-soft: color-mix(in oklab, hsl(var(--card)) 86%, hsl(var(--background)) 14%);\n\n\t/* ── Geometry ─────────────────────────────────────────────────────────── */\n\t--tst-radius-sm: 6px;\n\t--tst-radius-md: 10px;\n\t--tst-radius-lg: 16px;\n\n\t/* ── Depth ────────────────────────────────────────────────────────────── */\n\t--tst-shadow-soft: hsl(var(--foreground) / 0.06);\n\t--tst-shadow-hard: hsl(var(--foreground) / 0.12);\n\t--tst-shadow-sm: 0 1px 2px var(--tst-shadow-soft), 0 0 0 1px hsl(var(--border) / 0.7);\n\t--tst-shadow-md:\n\t\t0 4px 6px -1px var(--tst-shadow-soft), 0 2px 4px -2px var(--tst-shadow-soft),\n\t\t0 0 0 1px hsl(var(--border) / 0.8);\n\t--tst-shadow-lg:\n\t\t0 18px 28px -10px var(--tst-shadow-hard), 0 6px 10px -4px var(--tst-shadow-soft),\n\t\t0 0 0 1px hsl(var(--border) / 0.85);\n\n\t/* ── Motion ───────────────────────────────────────────────────────────── */\n\t--tst-motion: 150ms;\n\t--tst-motion-lg: 240ms;\n\t--tst-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n\n\t/* ── Layout ───────────────────────────────────────────────────────────── */\n\t/* The single source of truth for panel sizing. useTestingShell reads the\n\t   numeric equivalents from TESTING_PANEL_LIMITS; these drive the CSS side\n\t   (rail width, header height, drawer width) so the two never drift. */\n\t--tst-header-h: 44px;\n\t--tst-rail-w: 44px;\n\t--tst-sessions-w-min: 200px;\n\t--tst-sessions-w-max: 360px;\n\t--tst-inspector-w-min: 280px;\n\t--tst-inspector-w-max: 560px;\n\t--tst-drawer-w: min(88vw, 340px);\n\n\t/* Reading measure for the conversation. Without a cap, a 1920px screen stretched every message,\n\t   plan table and result card edge-to-edge — technically \"responsive\", unreadable in practice.\n\t   The gutter scales with the column so the thread keeps its margins as panels resize. */\n\t--tst-measure: 860px;\n\t--tst-gutter: clamp(12px, 2.5vw, 32px);\n}\n\n.tst-route {\n\tfont-size: var(--tst-fs-body);\n\tline-height: var(--tst-leading-body);\n\tcolor: var(--tst-text);\n\tbackground: var(--tst-app-bg);\n}\n\n/* ── Panel chrome ───────────────────────────────────────────────────────── */\n\n.tst-route .tst-panel {\n\tbackground: linear-gradient(\n\t\t180deg,\n\t\tcolor-mix(in oklab, var(--tst-panel-bg) 98%, hsl(var(--foreground)) 2%),\n\t\tvar(--tst-panel-bg)\n\t);\n\tborder-color: var(--tst-divider);\n}\n\n.tst-route .tst-workspace {\n\tbackground: linear-gradient(\n\t\t180deg,\n\t\tcolor-mix(in oklab, hsl(var(--background)) 99%, hsl(var(--foreground)) 1%),\n\t\thsl(var(--background))\n\t);\n}\n\n.tst-route .tst-header {\n\tmin-height: var(--tst-header-h);\n\tborder-bottom: 1px solid var(--tst-divider);\n\tbackground: linear-gradient(\n\t\t180deg,\n\t\tcolor-mix(in oklab, var(--tst-panel-bg) 96%, hsl(var(--foreground)) 4%),\n\t\tvar(--tst-panel-bg)\n\t);\n}\n\n/* Sub-header strip inside a panel (tab bars, section toolbars). */\n.tst-route .tst-toolbar {\n\tmin-height: 34px;\n\tborder-bottom: 1px solid color-mix(in oklab, var(--tst-divider) 46%, transparent);\n\tbackground: color-mix(in oklab, var(--tst-panel-bg) 86%, transparent);\n}\n\n/* ── Type utilities ─────────────────────────────────────────────────────── */\n\n.tst-route .tst-micro {\n\tfont-size: var(--tst-fs-micro);\n\tfont-weight: 600;\n\tletter-spacing: var(--tst-tracking-micro);\n\tline-height: var(--tst-leading-tight);\n\ttext-transform: uppercase;\n\tcolor: var(--tst-text-muted);\n}\n\n.tst-route .tst-meta {\n\tfont-size: var(--tst-fs-meta);\n\tline-height: var(--tst-leading-tight);\n\tcolor: var(--tst-text-muted);\n}\n\n.tst-route .tst-title {\n\tfont-size: var(--tst-fs-title);\n\tfont-weight: 600;\n\tletter-spacing: -0.011em;\n\tline-height: 1.3;\n\tcolor: var(--tst-text);\n}\n\n.tst-route .tst-hero {\n\tfont-size: var(--tst-fs-hero);\n\tfont-weight: 600;\n\tletter-spacing: -0.014em;\n\tline-height: 1.25;\n\tcolor: var(--tst-text);\n}\n\n/* ── Interactive (lift + focus ring) ───────────────────────────────────── */\n\n.tst-route .tst-interactive {\n\ttransition:\n\t\tbackground-color var(--tst-motion) var(--tst-ease),\n\t\tbox-shadow var(--tst-motion) var(--tst-ease),\n\t\tcolor var(--tst-motion) var(--tst-ease);\n}\n\n.tst-route .tst-interactive:focus-visible {\n\toutline: 2px solid var(--tst-accent);\n\toutline-offset: 2px;\n}\n\n/* ── Overlay drawer (session list / inspector below the lg breakpoint) ──── */\n\n.tst-route .tst-drawer {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\twidth: var(--tst-drawer-w);\n\tmax-width: var(--tst-drawer-w);\n\tz-index: 30;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n\tbackground: var(--tst-panel-bg);\n\tbox-shadow: var(--tst-shadow-lg);\n\ttransition:\n\t\ttransform var(--tst-motion-lg) var(--tst-ease),\n\t\topacity var(--tst-motion-lg) var(--tst-ease);\n}\n\n.tst-route .tst-drawer[data-side=\"left\"] {\n\tleft: 0;\n\tborder-right: 1px solid var(--tst-divider);\n\tborder-top-right-radius: var(--tst-radius-lg);\n\tborder-bottom-right-radius: var(--tst-radius-lg);\n\ttransform: translateX(-100%);\n\topacity: 0;\n}\n\n.tst-route .tst-drawer[data-side=\"right\"] {\n\tright: 0;\n\tborder-left: 1px solid var(--tst-divider);\n\tborder-top-left-radius: var(--tst-radius-lg);\n\tborder-bottom-left-radius: var(--tst-radius-lg);\n\ttransform: translateX(100%);\n\topacity: 0;\n}\n\n.tst-route .tst-drawer[data-open=\"true\"] {\n\ttransform: translateX(0);\n\topacity: 1;\n}\n\n/* ── Conversation ───────────────────────────────────────────────────────── */\n\n/*\n * One centred reading column. Every block in the thread — user bubble, answer, plan card, run result,\n * composer — uses `.tst-measure` so they share one left and one right edge as the panel resizes.\n */\n.tst-route .tst-measure {\n\twidth: 100%;\n\tmax-width: var(--tst-measure);\n\tmargin-inline: auto;\n\tpadding-inline: var(--tst-gutter);\n}\n\n/* One question-and-answer exchange. The hairline is the only separator in the thread; cards inside a\n   turn are grouped by proximity instead of each carrying its own border. */\n.tst-route .tst-turn {\n\tpadding-block: 20px;\n\tborder-bottom: 1px solid color-mix(in oklab, var(--tst-border) 55%, transparent);\n}\n.tst-route .tst-turn:last-of-type {\n\tborder-bottom: 0;\n}\n\n/* The user's message: right-aligned, tinted, with the corner nearest the sender squared off. */\n.tst-route .tst-user-bubble {\n\tmax-width: min(80%, 560px);\n\tpadding: 9px 13px;\n\tborder-radius: var(--tst-radius-md) var(--tst-radius-md) 4px var(--tst-radius-md);\n\tbackground: color-mix(in oklab, hsl(var(--primary)) 10%, hsl(var(--card)));\n\tborder: 1px solid color-mix(in oklab, hsl(var(--primary)) 22%, var(--tst-border));\n\tcolor: var(--tst-text);\n\tfont-size: var(--tst-fs-body);\n\tline-height: 1.55;\n\twhite-space: pre-wrap;\n\toverflow-wrap: anywhere;\n\tmax-height: 220px;\n\toverflow-y: auto;\n}\n\n/* The agent's live reasoning. A left accent rule rather than a full card, so an in-flight turn reads\n   as \"in progress\" and does not compete with the finished answers above it. */\n.tst-route .tst-thinking {\n\tbackground: var(--tst-surface-soft);\n\tborder-left: 2px solid hsl(var(--primary) / 0.85);\n\tborder-radius: 0 var(--tst-radius-sm) var(--tst-radius-sm) 0;\n\tpadding: 10px 14px;\n}\n\n/*\n * Agent prose. A markdown table or a long code fence is wider than the reading measure on a narrow\n * column, and was simply CLIPPED — the columns past the edge were unreachable. Each wide child\n * becomes its own scroll container so only that block scrolls, never the page.\n */\n.tst-route .tst-prose {\n\t/* Agent prose is full of unbreakable strings — CSS selectors, record ids, URLs, stack frames.\n\t   Without this a single long token stretched the message past the reading measure and was clipped\n\t   with no way to scroll to it. */\n\toverflow-wrap: anywhere;\n}\n\n.tst-route .tst-prose table {\n\tdisplay: block;\n\twidth: max-content;\n\tmax-width: 100%;\n\toverflow-x: auto;\n}\n.tst-route .tst-prose pre {\n\tmax-width: 100%;\n\toverflow-x: auto;\n}\n.tst-route .tst-prose img {\n\tmax-width: 100%;\n\theight: auto;\n}\n\n/* ── Composer ───────────────────────────────────────────────────────────── */\n\n.tst-route .tst-composer-dock {\n\tborder-top: 1px solid color-mix(in oklab, var(--tst-divider) 60%, transparent);\n\tbackground: linear-gradient(\n\t\t180deg,\n\t\tcolor-mix(in oklab, var(--tst-app-bg) 60%, transparent),\n\t\tvar(--tst-panel-bg)\n\t);\n}\n\n.tst-route .tst-composer-shell {\n\tbackground: color-mix(in oklab, hsl(var(--background)) 88%, hsl(var(--card)) 12%);\n\tborder: 1px solid var(--tst-border);\n\tborder-radius: var(--tst-radius-md);\n\tbox-shadow: 0 10px 24px -22px hsl(var(--foreground) / 0.35);\n\ttransition:\n\t\tborder-color var(--tst-motion) var(--tst-ease),\n\t\tbox-shadow var(--tst-motion) var(--tst-ease);\n}\n.tst-route .tst-composer-shell:focus-within {\n\tborder-color: hsl(var(--primary) / 0.55);\n\tbox-shadow: 0 0 0 3px hsl(var(--primary) / 0.12);\n}\n\n/* ── Entrance ───────────────────────────────────────────────────────────── */\n\n@keyframes tst-fade-up {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translateY(4px);\n\t}\n\t100% {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n\n.tst-route .tst-fade-up {\n\tanimation: tst-fade-up var(--tst-motion-lg) var(--tst-ease) both;\n}\n\n/* ── Reduced motion ─────────────────────────────────────────────────────── */\n/*\n * The module ships several always-on decorative animations (the result mascot's\n * float/shake, the idle browser scan line, shimmer sweeps on active steps, ping\n * dots). None of them carry information that isn't also in text, so they are all\n * stopped for users who ask for reduced motion. Panel transforms are kept but\n * made instant so layout still lands in the right place.\n */\n@media (prefers-reduced-motion: reduce) {\n\t.tst-route .tst-drawer,\n\t.tst-route .tst-interactive {\n\t\ttransition-duration: 1ms;\n\t}\n\n\t.tst-route .tst-fade-up {\n\t\tanimation: none;\n\t}\n\n\t.tst-route [data-tst-decorative-motion] {\n\t\tanimation: none !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
